import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

import useIsFilterInModal from '../../hooks/useIsFilterInModal';
import FilterLayout from '../FilterLayout';
import FilterModal from '../FilterModal';
import Header from './Header';

const FilterPanel = (props) => {

    const {
        selectedFilters,
        loading,
        loadFields,
        addSelectedFilter,
        removeSelectedFilter,
        closeFilterModal,
        clearFilters,
        applyFilters,
        resetFilters,
        data,
        filtersConfig,
    } = props;

    const isFilterInModal = useIsFilterInModal();
    const dictionary = useDictionary();
    const quickSearchRef = React.useRef(null);
    const closeButtonRef = useRef(null); // first button, for focus trap
    const applyFilterButtonRef = useRef(null); // last button, for focus trap

    const body = (
        <FilterLayout
            loadFields={loadFields}
            data={data}
            loading={loading}
            selectedFilters={selectedFilters}
            addSelectedFilter={addSelectedFilter}
            removeSelectedFilter={removeSelectedFilter}
            filtersConfig={filtersConfig}
        />
    );

    const clearAllButton = selectedFilters.length > 0
        ? (
            <Button
                label={dictionary.clear_all_text ?? 'Clear All'}
                size={'md'}
                shape={'hollow-borderless'}
                styleName={'link-blue'}
                handlers={{
                    'onClick': () => {

                        clearFilters();
                        Tracking.trackClearAllButtonClick();

                    },
                }}
            />
        )
        : undefined;

    if (isFilterInModal) {

        return (
            <FilterModal
                onClosedHandler={() => {

                    resetFilters();
                    Tracking.trackFiltersMobileModalCloseButtonClick();

                }}
                onOpenedHandler={() => {

                    quickSearchRef.current && quickSearchRef.current.focus();
                    Tracking.trackFiltersMobileModalOpened();

                }}
                onAddFiltersHandler={{
                    'onClick': () => {

                        applyFilters();
                        closeFilterModal();
                        Tracking.trackMobileModalApplyButtonClick();

                    },
                }}
                applyFilterButtonRef={applyFilterButtonRef}
                closeButtonRef={closeButtonRef}
                clearAllButton={clearAllButton}
            >
                {body}
            </FilterModal>
        );

    }

    return (
        <>
            <Header clearAllButton={clearAllButton} />
            {body}
        </>
    );

};

FilterPanel.propTypes = {
    selectedFilters: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    loadFields: PropTypes.func.isRequired,
    addSelectedFilter: PropTypes.func.isRequired,
    removeSelectedFilter: PropTypes.func.isRequired,
    closeFilterModal: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    applyFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    data: PropTypes.shape(),
    filtersConfig: PropTypes.array,
};

FilterPanel.defaultProps = {
    data: undefined,
    filtersConfig: [],
};

export default FilterPanel;
